import { useMemo } from 'react';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { STRIPE_ELEMENTS_DEFAULT_OPTIONS } from '@web/account/constants';
import getConfig from '@web/config/getConfig';

type Props = {
  children: JSX.Element;
  totalPrice?: number;
};

const config = getConfig();
const stripePromise = loadStripe(config.STRIPE_PUBLIC_KEY);

export const WithStripeManualPaymentMethod = ({ children, totalPrice = 0 }: Props) => {
  const stripeElementsOptions = useMemo(
    () =>
      ({
        ...STRIPE_ELEMENTS_DEFAULT_OPTIONS,
        amount: Math.max(0, Math.floor(totalPrice * 100)),
        mode: 'subscription',
        currency: 'usd',
        paymentMethodCreation: 'manual',
      }) as StripeElementsOptions,
    [totalPrice]
  );

  return (
    <Elements stripe={stripePromise} options={stripeElementsOptions}>
      {children}
    </Elements>
  );
};
